$(document).ready(function () {

    if (!$('#edit-reset').length) {
        $('.filters__toggle').removeClass('filters__toggle--hidden');
    }

    $(".filters__reset").on('click', function (e) {
        e.preventDefault();
        window.location.href = window.location.href.split('?')[0];
    });

    function changeIcon() {
        var map = $('.map-content');
        var btn = $('.filters__toggle');

        // if(map.hasClass('map__search--active')) {
        //     btn.removeClass('filters__toggle--hidden');
        // } else {
        //     btn.addClass('filters__toggle--hidden');
        // }
    }

    $('.filters__toggle').on('click', function() {
        $('.map-search-toggle').trigger('click');
        changeIcon();
    });

    $('.column-close').on('click', function() {
        $('.result-map-search-toggle').trigger('click');
        changeIcon();
    });

    $('.filters-btn-open').on('click', function() {
        $(this).toggleClass('is-active');
        $('.colPos90').toggleClass('-opened');
    });

    var searchResults = document.querySelector('.no-margin');

    function searchResultatsCount() {
        var numberOfSearchResults = document.querySelectorAll('.no-margin li').length,
            countDiv = document.querySelector('.container-results');

        countDiv.innerHTML = numberOfSearchResults + " ";
    }

    if (searchResults !== null) {
        searchResultatsCount();
    }

});
